export default new Promise((resolve) => {
  // TODO: DrawingManager removed in Maps JS API v3.65 (May/June 2026).
  // Migrate MarketAnalysisGoogleMap to a different drawing library before upgrading past v=3.64.
  // Before this change, the version was set to beta
  // See: https://developers.google.com/maps/deprecations
  const googleURL = `https://maps.googleapis.com/maps/api/js?key=${
    import.meta.env.VITE_GOOGLE_API_KEY
  }&libraries=drawing,places,geometry,maps&v=3.64`
  const script = document.createElement('script')
  script.src = googleURL
  document.head.appendChild(script)
  script.onload = () => {
    resolve(window['google'])
  }
})
